import React from "react";
const icon = (
  <svg
    width="640"
    height="512"
    viewBox="0 0 640 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_12)">
      <path
        d="M392.8 1.2C375.8 -3.7 358.1 6.2 353.2 23.2L225.2 471.2C220.3 488.2 230.2 505.9 247.2 510.8C264.2 515.7 281.9 505.8 286.8 488.8L414.8 40.8C419.7 23.8 409.8 6.1 392.8 1.2ZM473.4 121.3C460.9 133.8 460.9 154.1 473.4 166.6L562.7 256L473.3 345.4C460.8 357.9 460.8 378.2 473.3 390.7C485.8 403.2 506.1 403.2 518.6 390.7L630.6 278.7C643.1 266.2 643.1 245.9 630.6 233.4L518.6 121.4C506.1 108.9 485.8 108.9 473.3 121.4L473.4 121.3ZM166.7 121.3C154.2 108.8 133.9 108.8 121.4 121.3L9.39999 233.3C-3.10001 245.8 -3.10001 266.1 9.39999 278.6L121.4 390.6C133.9 403.1 154.2 403.1 166.7 390.6C179.2 378.1 179.2 357.8 166.7 345.3L77.3 256L166.7 166.6C179.2 154.1 179.2 133.8 166.7 121.3Z"
        fill="#8803E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_12">
        <rect width="640" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default icon;
